import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil, Nillable } from '@web/utils';
import { UserStatus } from '../enums/user-status';
import { UserStatusProviderService } from '../providers/user-status.provider.service';

@Pipe({
  name: 'userStatusLabel',
  standalone: true,
})
export class UserStatusLabelPipe implements PipeTransform {
  private readonly provider = inject(UserStatusProviderService);

  public transform(status: Nillable<UserStatus>): Observable<Nillable<string>> {
    if (isNil(status)) {
      return of(status);
    }

    return this.provider.label(status);
  }
}
